import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Paper,
  Popover,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { useTranslation } from "react-i18next";
import { SearchSettings, SearchTagSettings } from "../types/search";

interface Props {
  anchorEl: HTMLButtonElement | undefined;
  onClose: () => void;
  settings: SearchSettings;
  tagSettings: SearchTagSettings;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onTagsChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  formControl: {
    margin: theme.spacing(3),
  },
}));

const SearchSettingsForm = ({
  onClose,
  anchorEl,
  onChange,
  onTagsChange,
  settings,
  tagSettings,
}: Props): JSX.Element => {
  const classes = useStyles();
  const { t } = useTranslation("map");

  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Paper className={classes.root}>
        <div className={classes.formControl}>
          <FormLabel component="legend">
            {t("search-settings-objects")}
          </FormLabel>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  color="secondary"
                  checked={settings.port}
                  onChange={onChange}
                  name="port"
                />
              }
              label={t("ports")}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="secondary"
                  checked={settings.vessel}
                  onChange={onChange}
                  name="vessel"
                />
              }
              label={t("vessels")}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="secondary"
                  checked={settings.aton}
                  onChange={onChange}
                  name="aton"
                />
              }
              label={t("atons")}
            />
          </FormGroup>
          <FormHelperText>{t("search-settings-objects-helper")}</FormHelperText>
        </div>
        <div className={classes.formControl}>
          <FormLabel component="legend">{t("search-settings-tags")}</FormLabel>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  color="secondary"
                  checked={tagSettings.vesselType}
                  onChange={onTagsChange}
                  name="vesselType"
                />
              }
              label={t("vessels:type")}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="secondary"
                  checked={tagSettings.destination}
                  onChange={onTagsChange}
                  name="destination"
                />
              }
              label={t("vessels:destination")}
            />
          </FormGroup>
        </div>
      </Paper>
    </Popover>
  );
};

export default SearchSettingsForm;
